<template>
  <main>
    <menus />
    <section class="content">
      <header class="search">
        <!-- 顶部筛选栏 -->
        <!-- <figure class="select">
          订单状态
          <el-select v-model="search.order_client_status" clearable placeholder="订单状态" @change="changeSearch">
            <el-option v-for="item in options.clientStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          签证类别
          <el-select v-model="search.visaKind" clearable placeholder="签证类别" @change="changeSearch">
            <el-option v-for="item in options.visaKind" :key="item.VisaKindID" :label="item.Name" :value="item.Name">
            </el-option>
          </el-select>
          签证形式
          <el-select v-model="search.visaForm" clearable placeholder="签证形式" @change="changeSearch">
            <el-option v-for="item in options.visaForm" :key="item.VisaFormID" :label="item.Name" :value="item.Name">
            </el-option>
          </el-select>
          日期选择
          <el-date-picker v-model="search.date" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            @change="changeSearch">
          </el-date-picker>
        </figure> -->
        <figure class="select">
          <el-select v-model="search.order_type" clearable placeholder="订单类型" @change="changeSearch">
            <el-option v-for="item in options.order_type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="search.FrontEndOrderStatus" clearable placeholder="订单状态" @change="changeSearch">
            <el-option v-for="item in options.FrontEndOrderStatus" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-select v-model="search.keyword_field" clearable placeholder="关键字" @change="changeSearch">
            <el-option v-for="item in options.keyword_field" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </figure>

        <div class="input">
          <el-input v-model="search.keyword" maxlength="30" @change="changeSearch" clearable placeholder="请输入搜索内容">
            <!-- <el-select v-model="search.keyword_type" slot="prepend" placeholder="请选择">
              <el-option label="订单号" value="OrderNO"></el-option>
              <el-option label="产品名称" value="ProductName"></el-option>
            </el-select> -->
            <el-button slot="append" icon="el-icon-search" @click="changeSearch"></el-button>
          </el-input>
        </div>

      </header>

      <el-table :data="orderList" v-loading="loading">
        <el-table-column align="center" width="130" prop="order_sn" label="订单号"></el-table-column>
        <el-table-column align="center" prop="spu_name" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="sku_name" label="套餐名称" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" width="100" label="金额">
          <template slot-scope="scope">
            <span class="bold">{{ scope.row.order_price }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="套餐单价">
          <template slot-scope="scope">
            <span class="bold">{{ scope.row.sku_price }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="center" width="150" label="状态">
          <template slot-scope="scope">
            {{ scope.row.status_label }}
          </template>
        </el-table-column>
        <el-table-column align="left" width="160" label="操作">
          <template slot-scope="scope">
            <nav>
              <router-link :to="{ name: 'orderDetail', query: { order_sn: scope.row.order_sn } }">查看详情</router-link>
              <router-link :to="{ name: 'order_payment', query: { order_sn: scope.row.order_sn } }" class="pay"
                v-show="scope.row.isPaid !== 1">支付</router-link>
              <!-- <a class="up" v-show="s.row.isPaid === 1">上传资料</a> -->
              <!-- <a class="cancel" v-show="s.row.isPaid === 1">取消</a> -->
            </nav>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background layout="prev, pager, next" :page-size.sync="search.page_size"
        :current-page.sync="search.page" :total="search.total" :hide-on-single-page="true" @current-change="changePage">
      </el-pagination>
    </section>

  </main>
</template>

<script>
import menus from '@components/menu';
import $orderPro from '@api/orderPro';
import tool from '@assets/js/tool';

export default {
  components: {
    menus
  },
  data() {
    return {
      loading: true,
      options: {},//下拉数据合集
      search: {
        keyword_field: '',//关键词类型
        order_type: 'V', //订单类型 默认签证
        FrontEndOrderStatus: 'All',//订单状态 默认 All 全部
        keyword: '',//关键词
        rows: 10,
        page: 1,
        total: 0
      },
      // pickerOptions: {
      //   shortcuts: [{
      //     text: '最近一周',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '最近一个月',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: '最近三个月',
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }]
      // },
      orderList: []
    }
  },
  created() {
    let _this = this;

    // 获取 订单基础数据
    $orderPro.getOrderBaseData().then(({ data: res }) => {
      let { FrontEndOrderStatus, keyword_field, order_type, status } = res;
      keyword_field.map((item) => {
        item.value = item.id;
        delete item.id;
      })
      _this.options = { FrontEndOrderStatus, keyword_field, order_type, status }
    })

    this.getList();
  },
  filters: {
    getPaidDesc(type) {
      const desc = ['待付款', '已付款', '部分付款'];
      return desc[type] || type || null;
    }
  },
  methods: {
    // 返回正常显示的价格
    setNormalPrice(price) {
      return tool.ConversionPrice(price)
    },
    // 跳转详情
    goDetail(id) {

    },
    // 切换页码
    changePage(page) {
      this.changeSearch('page', page);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    // 更新搜索条件
    changeSearch(attr, value) {
      let data = {};
      console.log('----更新搜索条件：', attr, value)
      attr && (data[attr] = value);
      if (attr && attr !== 'page') { data.page = 1; }
      this.search = { ...this.search, ...data };
      this.getList();
    },
    // 获取订单列表
    getList() {
      let _this = this;
      const { keyword_field, order_type, FrontEndOrderStatus, keyword, rows, page } = _this.search;
      let postData = { keyword_field, order_type, FrontEndOrderStatus, keyword, rows, page };
      $orderPro.getOrderList(postData).then((res) => {
        const listData = res.data;
        res.data.data.map((item) => {
          item.order_price = tool.ConversionOtherPrice(item.order_price)
          item.sku_price = tool.ConversionPrice(item.sku_price)
          item.extra_price = tool.ConversionOtherPrice(item.extra_price)

        })
        _this.orderList = res.data.data;
        this.search.total = listData.total;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped src="./orderCenter.css"></style>